import {
    min,
    max,
    mean,
    median,
    sum,
    product,
    harmonicMean,
    rootMeanSquare,
    variance,
    standardDeviation,
    medianAbsoluteDeviation,
    interquartileRange,
} from 'simple-statistics';

export default {
    minimum: {
        f: min,
        suggestedLabel: 'lowest',
    },
    maximum: {
        f: max,
        suggestedLabel: 'highest',
    },
    mean: {
        f: mean,
        suggestedLabel: 'average',
    },
    median: {
        f: median,
        suggestedLabel: 'median',
    },
    // 'mode': SimpleStats.mode, // TODO allow sf control (e.g for mode)
    // 'quantile': SimpleStats.quantile, // Special attention needed to enter a quantile
    range: {
        f: (x: number[]) => {
            return max(x) - min(x);
        },
        suggestedLabel: 'the range of',
    },
    first: {
        f: (x: any[]) => {
            return x[0];
        },
        suggestedLabel: 'the first data point of',
    },
    middle: {
        f: (x: string | any[]) => {
            return x[Math.floor(x.length / 2)];
        },
        suggestedLabel: 'the middle data point of',
    },
    last: {
        f: (x: string | any[]) => {
            return x[x.length - 1];
        },
        suggestedLabel: 'the last data point of',
    },
    sum: {
        f: sum,
        suggestedLabel: 'the sum of',
    },
    product: {
        f: product,
        suggestedLabel: 'the product of',
    },
    'harmonic mean': {
        f: harmonicMean,
        suggestedLabel: 'the harmonic mean of',
    },
    // 'geometric mean': {
    //   f: SimpleStats.geometricMean,
    //   suggestedLabel: 'the geometric mean of'
    // },
    'root mean square': {
        f: rootMeanSquare,
        suggestedLabel: 'the root mean square (RMS) of',
    },
    variance: {
        f: variance,
        suggestedLabel: 'the variance of',
    },
    'standard deviation': {
        f: standardDeviation,
        suggestedLabel: 'the standard deviation of',
    },
    'median absolute deviation': {
        f: medianAbsoluteDeviation,
        suggestedLabel: 'the median absolute deviation of',
    },
    'interquartile range': {
        f: interquartileRange,
        suggestedLabel: 'the interquartile range of',
    },
};
